import { useState, useEffect } from 'react';
import 'normalize.css';
import axios from 'axios';
import { NavLink, useSearchParams } from 'react-router-dom';
import phoneIcon from '../assets/phoneIcon.svg';

export const DirectoryLink = ({ apiUrl }) => {
  const [show, setShow] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!apiUrl) return;
    checkDisplay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiUrl]);

  const checkDisplay = async () => {
    try {
      const checkResponse = await axios.post(
        `${apiUrl}/intercom/show`,
        {
          string: `fX${window.location.href.split('fX')[1]}`,
        },
        { timeout: 10000 }
      );

      if (checkResponse.status === 200) {
        const showLink = checkResponse.data.display;
        setShow(showLink);
      }
    } catch (e) {
      console.error(e);
    }
  };

  // Build the directory link with existing query parameters
  const directoryPath = `/directory?${searchParams.toString()}`.slice(0, -1);

  return (
    <div style={{ width: "80%", height: "3em", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", paddingTop: "2em" }}>
        {show ? <NavLink id="directorylink" to={directoryPath} style={{display: "flex", padding: "0.7em", border: "0.2px solid gray", borderRadius: "15px", color: "white", fontWeight: "bold", fontSize: "1em"}}><img id="phoneicon" alt="phone icon" src={phoneIcon} style={{width: "1.1em", paddingRight: "0.5em"}}></img>INTERCOM</NavLink> : null}
    </div>
  );
};